<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        d="M2,3.0000001999999997L2,11L14.000001,11L14,3.0000001000000003C14,2.44771528,13.552285,2,13,2L12,2L12,5.5999999Q12,6.0326233,11.6130486,6.2260985Q11.226099,6.4195738,10.8800001,6.1600003L9.5,5.125L8.1199999,6.1599998Q7.7739,6.4195747,7.3869495,6.2260981Q7,6.0326223,7,5.599999L7,2L3.0000001000000003,2C2.44771528,2,2,2.44771528,2,3.0000001999999997ZM8,2L8,4.999999799999999L9.1999998,4.0999999C9.3777781,3.9666666,9.6222219,3.9666666,9.8000002,4.0999999L11,5.000000200000001L11,2L8,2ZM2,13C2,13.552285,2.44771528,14,3.0000001999999997,14L13,14C13.552285,14,14,13.552285,14,13L14.000001,12L2,12L2,13Z"
        fill-rule="evenodd"
        fill="currentColor"
        fill-opacity="1"
      />
    </g>
  </svg>
</template>
